import { NgIf } from "@angular/common";
import { Component } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { Router, RouterLink, RouterLinkActive } from "@angular/router";
import { LoginVO } from "@core/api/v1";
import { LoginService } from "@core/services/login/login.service";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

@Component({
    selector: 'app-login',
    standalone: true,
    imports: [
        RouterLink,
        RouterLinkActive,
        FormsModule,
        ReactiveFormsModule,
        NgIf,
        FaIconComponent,
    ],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss',
})
export class LoginComponent {
    loginForm = this.formbuilder.group({
            username: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$")]],
            password: ['', Validators.required],
        },
    );

    loginVO: LoginVO;
    loginInvalid: boolean;

    constructor(private formbuilder: FormBuilder,
                private loginService: LoginService,
                private router: Router) {

    }

    login() {
        this.loginAktualisieren();
        this.loginService.login(this.loginVO);

        this.loginInvalid = (this.loginService.holeEingeloggtenUser() == null);

        this.clearLogin();
        this.router.navigate(["/home"]);
    }

    loginAktualisieren() {
        const formValue = this.loginForm.value;
        this.loginVO = {
            username: formValue.username!,
            password: formValue.password!,
        }
    }

    clearLogin() {
        this.loginForm.reset();
        this.loginAktualisieren();
    }
}
